import { ReactElement } from 'react';
import { Form, Input } from 'antd';
import { PHONE_PATTERN } from '../../../../../shared/phonePattern';

const Fields = (): ReactElement => (
  <>
    <Form.Item
      label='氏名'
      name='name'
      rules={[
        { required: true, message: '氏名を入力してください' },
        { whitespace: true, message: '氏名を入力してください' },
        { max: 100, message: '氏名は100文字以内で入力してください' },
      ]}
    >
      <Input placeholder='山田太郎' />
    </Form.Item>

    <Form.Item
      label='固定電話番号'
      name='phone'
      rules={[
        { pattern: PHONE_PATTERN, message: '電話番号は10-11桁の数字で入力してください' },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const mobilePhone = getFieldValue('mobilePhone') as string | undefined;
            if (!value && !mobilePhone) {
              return Promise.reject(new Error('固定電話番号か携帯電話番号のいずれかを入力してください'));
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input placeholder='0312345678' />
    </Form.Item>

    <Form.Item
      label='携帯電話番号'
      name='mobilePhone'
      rules={[
        {
          pattern: PHONE_PATTERN,
          message: '携帯電話は10-11桁の数字で入力してください',
        },
        ({ getFieldValue }) => ({
          validator(_, value) {
            const phone = getFieldValue('phone') as string | undefined;
            if (!value && !phone) {
              return Promise.reject(new Error('固定電話番号か携帯電話番号のいずれかを入力してください'));
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <Input placeholder='09012345678' />
    </Form.Item>
  </>
);

export default Fields;
